angular.module('picmonicng').filter('evenIndex', function () {
  return function (input) {
    var toReturn = [];
    for (a in input) {
      if (a == 0 || a % 2 == 0) {
        toReturn.push(input[a]);
      }
    }

    return toReturn;
  };
});
